# Nutrición: Dieta, Porciones & Hábitos Alimentarios

Lo que come tu mascota influye en su energía, peso, pelaje y salud a largo plazo. Las porciones consistentes, los ingredientes de calidad y las comidas regulares marcan la mayor diferencia.

<ArticleImage
  src="/images/guide/food-pet-bowl.jpg"
  alt="Tazón equilibrado de comida para mascotas"
  caption="Las porciones y la constancia importan tanto como los ingredientes."
/>

---

<Section emoji="⚖️" title="Porciones & Condición Corporal">

<Tip label="Mide las comidas" text="Usa un medidor o báscula para evitar el sobrepeso gradual." />
<Tip label="Revisa la silueta" text="Las costillas deben sentirse con facilidad y la cintura debe verse levemente desde arriba." />
<Tip label="Presupuesto de premios" text="Mantén los premios por debajo del 10% de las calorías diarias." />

</Section>

<ArticleImage
  src="/images/guide/food-rabbit.jpg"
  alt="Comida equilibrada en un plato"
  caption="Un tazón balanceado incluye proteína, fibra y grasas esenciales."
/>

<Section emoji="🥩" title="Elige la Dieta Correcta">

<Tip label="Etapa de vida" text="Cachorros, adultos y mayores necesitan perfiles de nutrientes distintos." />
<Tip label="Necesidades de salud" text="Problemas renales, alergias o peso suelen requerir dietas guiadas por el veterinario." />
<Tip label="Constancia" text="Mantén marcas y fórmulas estables para reducir molestias digestivas." />

<Callout>
Si estás considerando una dieta cruda o casera, consulta con tu veterinario para asegurar que sea completa y segura.
</Callout>

</Section>

<ArticleImage
  src="/images/guide/food-pet-water.jpg"
  alt="Vaso de agua"
  caption="La hidratación favorece la digestión y la salud urinaria."
/>

<Section emoji="💧" title="Hidratación & Premios Inteligentes">

<Tip label="Agua fresca" text="Renueva los tazones a diario y agrega recipientes extra en hogares con varias mascotas." />
<Tip label="Los gatos necesitan humedad" text="La comida húmeda o las fuentes de agua ayudan a que los gatos beban más." />
<Tip label="Alimentos a evitar" text="Mantén el chocolate, uvas/pasas, cebolla y xilitol fuera del alcance de las mascotas." />

</Section>

<Disclaimer title="⚠️ Recordatorio Amigable">
Esta guía es educativa y no sustituye la orientación veterinaria. Cambios bruscos en el apetito, vómitos o diarrea deben comentarse con tu veterinario.
</Disclaimer>
